// Test IDs for the admin authentication feature (Phase 2B-1A).

export const ADMIN_LOGIN = {
        page: 'admin-login-page',
        emailInput: 'admin-login-email-input',
        passwordInput: 'admin-login-password-input',
        submitButton: 'admin-login-submit-button',
        error: 'admin-login-error',
};

export const ADMIN_HOME = {
        page: 'admin-home-page',
        email: 'admin-home-email',
        settingsLink: 'admin-home-settings-link',
        logoutButton: 'admin-logout-button',
};

export const ADMIN_SETTINGS = {
        page: 'admin-settings-page',
        backLink: 'admin-settings-back-link',
        currentEmail: 'admin-settings-current-email',
        // Change email
        emailCurrentPasswordInput: 'admin-settings-email-current-password-input',
        newEmailInput: 'admin-settings-new-email-input',
        changeEmailButton: 'admin-settings-change-email-button',
        emailError: 'admin-settings-email-error',
        // Change password
        currentPasswordInput: 'admin-settings-current-password-input',
        newPasswordInput: 'admin-settings-new-password-input',
        confirmPasswordInput: 'admin-settings-confirm-password-input',
        changePasswordButton: 'admin-settings-change-password-button',
        passwordError: 'admin-settings-password-error',
};

export const ADMIN_NAV = {
        ordersLink: 'admin-nav-orders',
        settingsLink: 'admin-nav-settings',
        logout: 'admin-nav-logout',
};

export const ADMIN_ORDERS = {
        page: 'admin-orders-page',
        search: 'admin-orders-search-input',
        filterOrderStatus: 'admin-orders-filter-order-status',
        filterPaymentStatus: 'admin-orders-filter-payment-status',
        filterArtworkStatus: 'admin-orders-filter-artwork-status',
        filterProduct: 'admin-orders-filter-product',
        clearFilters: 'admin-orders-clear-filters',
        table: 'admin-orders-table',
        row: 'admin-order-row',
        view: 'admin-order-view',
        loading: 'admin-orders-loading',
        empty: 'admin-orders-empty',
        error: 'admin-orders-error',
        prev: 'admin-orders-prev',
        next: 'admin-orders-next',
        pageInfo: 'admin-orders-page-info',
        total: 'admin-orders-total',
};

export const ADMIN_ORDER_DETAIL = {
        page: 'admin-order-detail-page',
        back: 'admin-order-detail-back',
        loading: 'admin-order-detail-loading',
        error: 'admin-order-detail-error',
        cardFront: 'admin-order-detail-card-front',
        cardBack: 'admin-order-detail-card-back',
        logo: 'admin-order-detail-logo',
        noLogo: 'admin-order-detail-no-logo',
        transitionButton: 'admin-order-status-transition',
        cancelButton: 'admin-order-cancel-button',
        cancelConfirm: 'admin-order-cancel-confirm',
        cancelDismiss: 'admin-order-cancel-dismiss',
        timeline: 'admin-order-detail-timeline',
        statusError: 'admin-order-detail-status-error',
};
